export const NO_DURATION_DEFINED = -1;
export const NO_RESULT_FROM_CACHE = '$$NO_RESULT$$';
var sh = require('shorthash');

export default class Cache {
  constructor() {
    this.map = {};
    this.timeouts = new Set();
  }

  getCacheKey(url = '', data = {}) {
    let cacheKey = sh.unique(url + '_' + JSON.stringify(data));
    return cacheKey;
  }

  genObjectKey(object) {
    return Buffer.from(JSON.stringify(object)).toString('base64');
  }

  set(key, value, duration = NO_DURATION_DEFINED) {
    this.map[key] = value;

    if (duration !== NO_DURATION_DEFINED) {
      const timeoutKey = setTimeout(() => {
        if (this.map[key]) {
          delete this.map[key];
        }
        this.timeouts.delete(timeoutKey);
      }, duration);
      this.timeouts.add(timeoutKey);
    }
  }

  get(key) {
    return this.map[key] || NO_RESULT_FROM_CACHE;
  }

  clear() {
    this.map = {};
    this.timeouts.forEach((timeout) => {
      clearTimeout(timeout);
    });
    this.timeouts.clear();
  }
}
